export default __webpack_public_path__ + "static/media/Mark-4-HUD-Targeting (Reticle).a482ab7d.jpg";